import React from "react";
import { PiBuildingOffice } from "react-icons/pi";
import { MdAddCall } from "react-icons/md";


const warningText = `Investment/Trading in Securities Market is subject to market risk. Read
        all the related documents carefully before investing. Please read the
        document of our privacy policy, terms of use & disclaimer on our
        website. We do not provide any guaranteed or assured return services,
        profit sharing services, Demat Account services, Investment related
        services, or any other services which are not mentioned on our website. ||
        शेयर बाजार में निवेश/ट्रेडिंग करना बाजार जोखिमों के अधीन है। निवेश करने से पहले सभी संबंधित दस्तावेज़ों को ध्यानपूर्वक पढ़ें। कृपया हमारी वेबसाइट पर उपलब्ध गोपनीयता नीति, उपयोग की शर्तें एवं अस्वीकरण को अवश्य पढ़ें। हम किसी भी प्रकार की गारंटीड या सुनिश्चित रिटर्न, लाभ साझाकरण, डीमैट खाता, निवेश सलाह अथवा ऐसी कोई अन्य सेवा प्रदान नहीं करते, जिसका उल्लेख हमारी वेबसाइट पर स्पष्ट रूप से नहीं किया गया है।
      `;
const Warning = () => {
  return (
    <div className="">
      {/* warnig */}
      <div className="w-full bg-gradient-to-br from-orange-700 to-orange-500 shadow-2xl overflow-hidden h-8 flex items-center">
        <div className="  flex items-center  text-white text-center m-auto    ">
          <marquee>{warningText}</marquee>
        </div>
      </div>
    </div>
  );
};

export default Warning;
